var chunkMapping = {
	"6779": [
		36779
	]
};
var idToExternalAndNameMapping = {
	"36779": [
		"default",
		"./store",
		48298
	]
};
var idToRemoteMap = {
	"36779": [
		{
			"externalType": "script",
			"name": "panel",
			"externalModuleId": 48298
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}